import templateUrl from 'emun.filemanager/file-manager.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import uploadMediaPrompt from 'emun.medialibrary/upload-media-prompt'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import modals from 'webmodals/modals'

class MediaLibraryController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
        let $rootScope = resolve('$rootScope');
		$ctrl.$on('$mediaUploaded', function () {
			$ctrl.query.load(true);
		});
		$ctrl.media = [];
    }
    $onInit(){
		const $ctrl = this;
		var url = 'QueryMediaLibrary.json' ;
		$ctrl.query = new AutoQuery({
			url: url,
			hideLeftNav: true,
			orderBy: '-Description',
			tagCriteria: {},
			autoLoad: true,
			pageSize: 12
		});
    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
    view(report){
        const $ctrl = this;
        ReportPrompt.open({report: report}).then(() => $ctrl.load());
	}
	createMedia() {
		const $ctrl = this;
		var options = {
		};
		uploadMediaPrompt.open(options).then(() => $ctrl.query.load());
	}
	editMedia(media) {
		const $ctrl = this;
		var options = {
			media: media
		};
		uploadMediaPrompt.open(options).then(() => $ctrl.query.load());
	}
	deleteMedia(media) {
		const $ctrl = this;
		return modals.confirm("Are you sure?", "Delete Media").result.then(function () {
			$ctrl.bus.send('DeleteMediaItem.json', media).then(function (response) {
				$ctrl.query.load();
			});
		});
	}
	openDocument(doc) {
		let $ctrl = this;
		window.open(doc.url, doc.label);
	}
}

export default MediaLibraryController;